import { useState } from "react";
import BaseDialog from "./modelDialogs/BaseDialog";
import { Task } from "./TaskAndMessageManager";
import { itx } from "./translationItx/itx";

export default function TaskDialog(props: { task: Task }) {
  const { task } = props;

  const interButtons = new Array<any>();
  const title = itx("TaskGroup." + task.group);
  let interactionTable: any = null;
  //////////////////////////////////////////////////////////////////////////
  function InteractionButton(props: { interaction: { id: string; caption: string; action: () => void } }) {
    const { interaction } = props;

    return (
      <button
        className="button"
        onClick={() => {
          interaction.action();
          state.taskAndMessageManager.removeTask(task);
          state.dialogManager.closeDialog();
        }}
      >
        {interaction.caption}
      </button>
    );
  }
  function InteractionRow(props: { interaction: { id: string; caption: string; action: () => void } }) {
    const { interaction } = props;
    return (
      <tr>
        <td>
          <input type="checkbox" className="checkbox" id={"checkbox_" + interaction.id} />
        </td>
        <td>{interaction.caption}</td>
      </tr>
    );
  }
  /////////////////////////////////////////////////////////////////////////////////////////
  function onOk(): boolean {
    task.interactions.forEach((inter) => {
      const checkboxField = document.getElementById("checkbox_" + inter.id);

      const checked = (checkboxField as any)?.checked;
      if (checked) {
        inter.action();
      }
    });
    state.taskAndMessageManager.removeTask(task);
    return true;
  }
  ///////////////////////////////////////////////////////////////////////////////////
  if (task.interactions.length <= 2) {
    task.interactions.forEach((inter) => {
      interButtons.push(<InteractionButton interaction={inter} />);
    });
  } else {
    /// create here checklist
    const rows = new Array<any>();
    task.interactions.forEach((inter) => {
      rows.push(<InteractionRow interaction={inter} />);
    });
    interactionTable = (
      <table>
        <tbody>{rows}</tbody>
      </table>
    );
  }

  return (
    <BaseDialog
      title={title}
      okCaption={itx("perform", "durchführen")}
      moreButtons={interButtons}
      noOkButton={interButtons.length == 2}
      noAbortButton={interButtons.length == 2}
      onOk={onOk}
    >
      {task.title}
      {interactionTable}
    </BaseDialog>
  );
}
